import { useNavigate } from "react-router-dom";
import { getOrgRoleName } from "../../../../_metronic/helpers/utils";

const MembersModalForm = ({
  members,
  isUserProfile,
  onClose
}) => {
const navigate = useNavigate()

  return (
    <>
        <div
          className="d-flex flex-column scroll-y me-n7 mh-300px min-h-auto"
        >
          <div className="members-table">
            <h5>Member Name</h5>
            <h5>Member ID</h5>
            <h5>Organization Role</h5>
          </div>
          {members?.sort((a, b) => a?.role - b?.role)?.map(el => (
            <div key={el?.member_id}  className="members-table">
              <h4 className="pointer hover"
              onClick={() => {
                navigate(`/users/${el?.member_uid}`)
                if (isUserProfile) {
                  onClose()
                }
              }}
              >{el?.member_name}</h4>
              <h4 className="pointer hover"
                 onClick={() => {
                  navigate(`/users/${el?.member_uid}`)
                  if (isUserProfile) {
                    onClose()
                  }
                }}
              >{el?.public_id}</h4>
              <h4
              >{getOrgRoleName(el?.role, el?.is_approved)}</h4>
            </div>
          ))}
        </div>
        <div className="text-center pt-15">
          <button
            type="reset"
            onClick={onClose}
            className="btn btn-light mx-3"
            data-kt-users-modal-action="cancel"
          >
            Close
          </button>
        </div>
    </>
  );
};

export { MembersModalForm };
